// extracted by mini-css-extract-plugin
module.exports = {"slider":"SectionCarouselItems_slider__FQF6I"};